import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";

import moment from "moment";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";

const ProductRequestList = (props) => {
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    //setSelectedData(data);
    //console.log(data);

    const Id = data && data.productRequestId;

    getProductRequest(
      {
        url: `/api/productRequest/?orgId=${localStorage.getItem(
          "orgId"
        )}&productRequestId=${Id}`,
      },
      (res) => {
        //console.log(res);
        setSelectedData(res);
      }
    );

    setIsModalOpen(true);

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const { addForm, update } = props;
  const [data, setData] = useState([]);

  const [docurl, setDocUrl] = useState(false);
  const [productRequestId, setProductRequestId] = useState([]);

  const viewPdf = (itemId) => {
    setDocUrl("https://www.orimi.com/pdf-test.pdf");
    setProductRequestId(itemId);
  };

  const { sendRequest: getProductRequest } = useHttp();

  const getData = () => {
    getProductRequest(
      {
        url: `/api/productRequest/?orgId=${localStorage.getItem("orgId")}&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        if (res) {
          // setData(res);
          const sortedData = res.sort(
            (a, b) => b.productRequestId - a.productRequestId
          );
          setData(sortedData);

          //console.log(res);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteProductRequest } = useHttp();

  const handleDelete = (e, data) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Product Request detail?",
      onOk() {
        if (data) {
          const updatedData = {
            productRequest: {
              ...data,
              status: 0,
              approvedDate: moment(new Date().toISOString().slice(0, 10)).format(
                "DD/MM/YYYY"
              ),
           
              approvedBy: parseInt(localStorage.getItem("id")),
            },
          };
          //console.log(updatedData);

          
          deleteProductRequest(
            {
              url: "/api/productRequest/",
              method: "PUT",
              body: updatedData,
            },
            (data) => {
              //console.log(data);
              toast.success("Product Request Deleted successfully");
              getData();
            }
          );
        }
      },
      onCancel() {},
    });
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "40%",
      borderRadius: "5px",
      maxWidth: "400px",
      maxHeight: "390px",
      height: "310px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const [approveData, setApproveData] = useState();

  const openApproveModal = (data) => {
    //setSelectedData(data);
    //console.log(data);
    setApproveData(data && data);

    setIsApproveOpen(true);
  };

  const closeApproveModal = () => {
    setIsApproveOpen(false);
  };

  const { sendRequest: putProductRequest } = useHttp();

  const handleStatus = (e, status) => {
    e.preventDefault();
    if (approveData) {
      const updatedApproveData = {
        productRequest: {
          ...approveData,
          approvedDate: moment(new Date().toISOString().slice(0, 10)).format(
            "DD/MM/YYYY"
          ),
          status: status,
          approvedBy: parseInt(localStorage.getItem("id")),
        },
      };
      //console.log(updatedApproveData);

      // setApproveData(updatedApproveData);
      putProductRequest(
        {
          url: "/api/productRequest/",
          method: "PUT",
          body: updatedApproveData,
        },
        (data) => {
          //console.log(data);
          toast.success("Product Request Update successfully");
          setIsApproveOpen(false);
        }
      );
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Product Request</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Product Request
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-sm table-bordered text-center">
                      <thead>
                        <tr className="">
                          <th>Date</th>
                          <th>Request No</th>
                          <th>Date of Requirement</th>
                          <th>Executive Name</th>
                          <th>Warehouse Name </th>

                          <th>Approve</th>
                          <th>Delete</th>
                          <th>View</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems &&
                          currentItems.map((x) => {
                            return (
                              <tr
                                className="tBoarder cursor_pointer"
                                style={{
                                  justifyContent: "center",
                                  textAlign: "center",
                                }}
                                key={x.productRequestId}
                              >
                                <td>{x.requestDate}</td>
                                <td>{x.productRequestNo}</td>
                                <td>{x.productRequirementDate}</td>
                                <td>{x.fieldExecutiveName}</td>
                                <td>{x.warehouseName}</td>

                                <td>
                                  {" "}
                                  <button
                                    className="btn"
                                    onClick={() => openApproveModal(x)}
                                  >
                                    <i className="fas fa-check-circle"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={(e) => handleDelete(e, x)}
                                    className="btn"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(x)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="">
          <h3 className="card-title">Product Details</h3>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setIsModalOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
        </div>

        {selectedData && (
          <div className="mx-3">
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Request No: {selectedData.productRequestNo}
              </p>
              <p className="col-md-6">
                Request Date : {selectedData.requestDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Product Requirement No: {selectedData.productRequirmentDate}
              </p>
              <p className="col-md-6">
                Field Executive Name : {selectedData.fieldExecutiveName}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Warehouse Name: {selectedData.warehouseName}
              </p>
            </div>

            <h5 className="card-title">Product Details</h5>
            <table className="table table-bordered text-center">
              <thead>
                <tr className="tableheaderrowview">
                  <th>Sr. No</th>

                  <th>Product SubType</th>
                  <th>Product Name</th>
                  <th>Quantity</th>

                  <th>Unit</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.productRequestDetails &&
                  selectedData.productRequestDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>

                        <td>{itm.productSubType}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.quantity}</td>
                        <td>{itm.unitAbbreviation}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>

      {isApproveOpen && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Request Approve</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsApproveOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <form>
            {/* onSubmit={submitApproveHandler} */}
            <div className="row">
              <label htmlFor="newPassword">Doc No: </label>
              <p>{approveData.productRequestNo}</p>
            </div>
            <div className="row">
              <label htmlFor="newPassword">Product Requirement Date:</label>
              <p>{approveData.productRequirementDate}</p>
            </div>
            <div className="row">
              <label htmlFor="newPassword">Sales Executive Name:</label>
              <p>{approveData.fieldExecutiveName}</p>
            </div>
            <br />
            <div className="row">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={(e) => handleStatus(e, 2)}
              >
                Approve
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="btn btn-danger"
                onClick={(e) => handleStatus(e, 3)}
              >
                Reject
              </button>
            </div>
          </form>
          <br />
        </Modal>
      )}
    </>
  );
};

export default ProductRequestList;
